<template>
  <div>
    <FbMemberHeader
      :type="type"
      :member="page" />
    <v-container class="mb-10">
      <v-form>
        <!-- BASIC INFO -->
        <h1 class="caption text-uppercase">Basic Info</h1>
        <v-row wrap>
          <v-col cols="12" sm="6" lg="4">
            <v-text-field
              v-model.trim="page.name"
              label="Name"
              filled
              required
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" lg="4">
            <v-text-field
              v-model.trim="page.category"
              label="Category"
              counter="40"
              filled
              required
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" lg="4">
            <v-text-field
              v-model.number="page.likeCount"
              label="Likes"
              type="number"
              filled
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" lg="4">
            <v-checkbox
              v-model="page.isLiked"
              label="Liked"
              hide-details
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="12">
            <v-textarea
              v-model="page.description"
              filled
              label="Description"
              counter="500"
              required
            ></v-textarea>
          </v-col>
        </v-row>
        <!-- PICTURES -->
        <FbMemberPictureGroup :member="page" />
      </v-form>
    </v-container>
  </div>
</template>

<script>
import FbMemberHeader from '../components/FbMemberHeader'
import FbMemberPictureGroup from '../components/FbMemberPictureGroup'

import { FbMember } from '../constants'
import { vueObjectAssign } from '../utils'

export default {
  name: 'FbPage',
  injectModels: ['Store'],
  components: {
    FbMemberHeader,
    FbMemberPictureGroup
  },
  created() {
    this.id = this.$route.params.id
    this.page = this.Store.fb.pages[this.id]

    vueObjectAssign(this.page, {
      name: '',
      profilePicture: '',
      coverPicture: '',
      featurePictures: [],
      category: 'Unknown',
      description: '',
      likeCount: 0,
      isLiked: false
    })
  },
  data() {
    return {
      id: '',
      page: {},
      type: FbMember.Page
    }
  }
}
</script>
